import { today } from '@/lib/format';

import type { JournalInput, JournalType } from './safeJournalApi';

/**
 * 양식 편집 창의 미리보기 종이(DOC-122 §20) — 빈 일지 한 장. 양식 편집은 일지를 쓰지 않으므로 칸은 비어 있고,
 * 고르는 쪽이 양식에서 오는 값(점검 항목 · 교육 기본값)만 덮어 넘긴다.
 */
export function previewJournal(type: JournalType, overrides: Partial<Omit<JournalInput, 'siteId'>> = {}): Omit<JournalInput, 'siteId'> {
  return {
    journalType: type,
    journalDate: today(),
    title: null,
    weather: null,
    temperature: null,
    authorName: null,
    educationKind: null,
    educationSubKind: null,
    educationMaterial: null,
    startTime: null,
    endTime: null,
    educationHours: null,
    instructor: null,
    target: null,
    headcount: null,
    place: null,
    inspector: null,
    workforce: null,
    content: null,
    specialNote: null,
    attendees: [],
    healthItems: [],
    findings: [],
    patrolNotes: [],
    activities: [],
    facilities: [],
    checks: [],
    tbm: null,
    ...overrides,
  };
}

/** 양식 편집 창 — 왼쪽 편집 칸 · 오른쪽 종이. 일지 작성 창(.sj-desk)과 같은 틀이다. */
export const FORM_DESK_STYLES = `
.sf-desk { display: grid; grid-template-columns: 460px minmax(0, 1fr); gap: 16px; height: calc(90vh - 120px); }
.sf-side { overflow-y: auto; min-height: 0; display: flex; flex-direction: column; gap: 12px; padding-right: 4px; }
.sf-panel { display: flex; flex-direction: column; gap: 10px; background: var(--bg-card, #fff); border: 1px solid var(--border); border-radius: 10px; padding: 12px 14px; }
.sf-title { font-size: 13px; font-weight: 700; }
.sf-field { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.sf-field > span { font-size: 12px; font-weight: 600; color: var(--text-secondary); }
.sf-row { display: grid; gap: 8px; }
.sf-paper { overflow: auto; min-height: 0; background: var(--bg-muted, #f1f5f9); border-radius: 10px; padding: 16px; }
.sf-paper > div { margin: 0 auto; }
@media (max-width: 1240px) {
  .sf-desk { grid-template-columns: minmax(0, 1fr); height: auto; }
  .sf-side, .sf-paper { overflow: visible; }
}
`;
